import type { FlatField } from '../types';

export function FieldMeta({ field }: { field: FlatField }) {
  const { node } = field;

  return (
    <div className="rounded-xl border p-3">
      <div className="text-sm">
        <span className="text-muted-foreground">Path:</span> <span className="font-mono">{field.path}</span>
      </div>

      <div className="text-sm">
        <span className="text-muted-foreground">Type:</span> <span className="font-mono">{node.type}</span>
        {node.nullable ? <span className="text-muted-foreground"> | null</span> : null}
        {node.required ? <span className="text-muted-foreground"> (required)</span> : null}
      </div>

      {node.type === 'string' && node.enum?.length ? (
        <div className="text-sm">
          <span className="text-muted-foreground">Enum:</span>{' '}
          <span className="font-mono">{JSON.stringify(node.enum)}</span>
        </div>
      ) : null}
    </div>
  );
}
